/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Price = 'Website.Product.ScreenReader.Price';
export const OriginalPrice = 'Website.Product.ScreenReader.OriginalPrice';
